import * as React from 'react';
import { MembershipItemIndexView } from '../../../types/membershipPlans';
import {
    SummaryBody,
    SummaryPriceRow,
    SummarySplitter,
    SummarySubPriceRow,
    SummaryTextRow,
    CampaignSummary,
} from './base';

type Props = {
    item: MembershipItemIndexView;
};

export class MembershipItemDetailedSummary extends React.Component<Props> {
    render() {
        const { item } = this.props;
        return (
            <SummaryBody>
                <SummaryTextRow label="プラン名" textAlign="right" text={item.name} />
                <SummarySubPriceRow label="金額" price={item.price} unit={'円（税別）'} />
                {item.discount_campaigns.map((d) => {
                    return d.discount > 0 && <CampaignSummary discount={d} unit={'円'} type="s" />;
                })}
                <SummarySubPriceRow label="消費税" price={item.tax} unit={'円'} />
                <SummarySplitter />
                <SummaryPriceRow label="合計" price={item.total_price} unit={'円(税込)'} />
            </SummaryBody>
        );
    }
}
